<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span class="card-title">清洗组</span>
            <div style="float:right;">
                <el-date-picker class="date_range mr8" :picker-options="pickerOptions" @change="getWashData" v-model="range" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
        </div>
        <div class="chart-data-dimension">
            <el-table class="chart-data-table" :show-summary="true" :summary-method="getSummaries" v-loading="loading" :data="tableData" height="300" style="width: 100%">
                <el-table-column prop="user" label="姓名" align="center">
                    <template slot-scope="scope">
                        {{scope.row.user.realname}}
                    </template>
                </el-table-column>
                <el-table-column prop="callernumber" label="分机号" align="center"></el-table-column>
                <el-table-column prop="totals" label="呼叫总数" align="center"></el-table-column>
                <el-table-column prop="success" label="接通数量" align="center"></el-table-column>
                <el-table-column prop="seconds" label="呼叫总时长" align="center">
                    <template slot-scope="scope">
                        {{secondsToHms(scope.row.seconds)}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </el-card>

</template>
<script>
import {
    secondsToHms
} from '@/utils/common.js';
import * as api from '@/api/module'
export default {
    props: {
        initWashData: {
            Type: Array,
            default: []
        }
    },
    watch: {
        initWashData: {
            handler(val) {
                this.tableData = val
            },
            deep: true,
            // 第一次渲染直接执行一次监听器
            immediate: true,
        }
    },
    data() {
        return {
            tableData: [],
            range: [],
            loading: false,
            sumFields: ['totals', 'success', 'seconds'],
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    beforeCreate() {
        this.secondsToHms = secondsToHms;

    },
    methods: {
        getWashData() {
            let _this = this;
            _this.loading = true
            let query = {
                range: _this.range,
            }
            api.wash(query)
                .then(res => {
                    if (res.code == 200) {
                        _this.tableData = res.data.wash;
                        _this.loading = false
                    } else {
                        _this.$message.error(res.msg);
                        return;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }

                if (this.sumFields.indexOf(column.property) < 0) {
                    sums[index] = '';
                    return;
                }

                const values = data.map(item => Number(item[column.property]));

                if (column.property === 'seconds') {
                    if (!values.every(value => isNaN(value))) {
                        let sum = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = sum;
                        this.$set(sums, 4, secondsToHms(sums[4]))
                    } else {
                        sums[index] = '';
                    }
                } else {
                    if (!values.every(value => isNaN(value))) {
                        let sum = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);

                        sums[index] = sum;
                    } else {
                        sums[index] = '';
                    }
                }

            });

            return sums;
        }

    }
}
</script>